import React, { useState, useEffect } from "react";

const CustomerForm = ({ initialData = {}, onSubmit }) => {
  const defaultData = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: ""
  };

  const [customer, setCustomer] = useState(defaultData);

  useEffect(() => {
    setCustomer({ ...defaultData, ...initialData });
  }, [initialData]);

  const onChange = (field, value) => {
    setCustomer((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(customer);
  };

  const reset = (e) => {
    e.preventDefault();
    setCustomer(initialData || defaultData);
  };

  return (
    <form className="p-3 border rounded">

      <div className="mb-3">
        <label className="form-label">First Name</label>
        <input
          type="text"
          className="form-control"
          value={customer.firstName}
          onChange={(e) => onChange("firstName", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Last Name</label>
        <input
          type="text"
          className="form-control"
          value={customer.lastName}
          onChange={(e) => onChange("lastName", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input
          type="email"
          className="form-control"
          value={customer.email}
          onChange={(e) => onChange("email", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone</label>
        <input
          type="tel"
          className="form-control"
          value={customer.phone}
          onChange={(e) => onChange("phone", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Address</label>
        <input
          type="text"
          className="form-control"
          value={customer.address}
          onChange={(e) => onChange("address", e.target.value)}
        />
      </div>

      <div className="row">
        <div className="col-md-5 mb-3">
          <label className="form-label">City</label>
          <input
            type="text"
            className="form-control"
            value={customer.city}
            onChange={(e) => onChange("city", e.target.value)}
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">State</label>
          <input
            type="text"
            className="form-control"
            value={customer.state}
            onChange={(e) => onChange("state", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">ZIP Code</label>
          <input
            type="text"
            className="form-control"
            value={customer.zip}
            onChange={(e) => onChange("zip", e.target.value)}
          />
        </div>
      </div>

      <div className="modal-btn-container">
        <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
        <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>
    </form>
  );
};

export default CustomerForm;
